module.exports = __webpack_public_path__ + "media/27.2be18791.mp3";